import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { initGA, trackPageView } from '../../lib/analytics';
import { captureAttribution } from '../../lib/attribution';

export default function Analytics() {
  const location = useLocation();

  useEffect(() => {
    // Initialize analytics services once on mount
    initGA();
  }, []);

  useEffect(() => {
    // Track page views on route change
    trackPageView(location.pathname + location.search);
    captureAttribution(location.search);
  }, [location]);

  return null; // This component doesn't render anything
}
